module.exports = __webpack_public_path__ + "static/media/ico-case-empty.762a19d8.svg";